module.exports = __webpack_public_path__ + "static/img/h2.5ef2c32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mb/h2.png
// module id = +D1I
// module chunks = 2